// src/components/bookings_manager/tour_guides/content/external_assignments/BatchActionsButton.tsx
import { useState } from "react";
import { Drawer, IconButton, Tooltip } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import BatchActionsDrawerContent from "./BatchActionsDrawerContent";

interface BatchActionsButtonProps {
  selectedItems: Array<{
    option_id: string;
    start_time_id: string;
    date: string;
    tour_group_id: string;
    product_id: string;
  }>;
  entities: any;
  refetch: () => void;
  allTourGroupsData?: Array<{
    tour_group_id: string;
    external_assignments?: Array<{
      _id: string;
      role_id: string;
      user_id: string;
    }>;
  }>;
}

const BatchActionsButton = ({
  selectedItems,
  entities,
  refetch,
  allTourGroupsData,
}: BatchActionsButtonProps) => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const handleOpenBatchActions = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenDrawer(true);
  };

  const handleCloseDrawer = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenDrawer(false);
  };

  return (
    <>
      <Tooltip title="Batch assign and add notes" placement="left" arrow>
        <IconButton
          onClick={handleOpenBatchActions}
          size="large"
          sx={{
            backgroundColor: "#ffa500",
            color: "#000",
            "&:hover": {
              backgroundColor: "#ff8c00",
            },
          }}
        >
          <GroupIcon />
        </IconButton>
      </Tooltip>

      <Drawer open={openDrawer} onClose={handleCloseDrawer}>
        <BatchActionsDrawerContent
          selectedItems={selectedItems}
          entities={entities}
          onClose={handleCloseDrawer}
          refetch={refetch}
          allTourGroupsData={allTourGroupsData}
        />
      </Drawer>
    </>
  );
};

export default BatchActionsButton;
